(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adp-home-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adp-parts-finder')) {
    customElements.define('adp-parts-finder', class extends HTMLElement {
      async connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.rawModels = JSON.parse(this.querySelector('[data-models]').textContent) || [];
        if (!this.rawModels.length && this.dataset.collectionUrl) {
          try {
            const dataUrl = new URL(this.dataset.collectionUrl, location.origin);
            dataUrl.searchParams.set('section_id','adp-vehicle-data');
            const response = await fetch(dataUrl, { signal: AbortSignal.timeout(10000) });
            if (!response.ok) throw new Error('Model data unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            this.rawModels = JSON.parse(html.querySelector('#AdpVehicleData')?.textContent || '[]') || [];
            this.querySelector('[data-models]').textContent = JSON.stringify(this.rawModels);
          } catch (error) { this.rawModels = []; }
        }
        this.groups = new Map();
        for (const raw of this.rawModels) {
          const label = this.canonical(raw);
          const brand = this.brandOf(label);
          if (!brand) continue;
          if (!this.groups.has(label)) this.groups.set(label, { label, brand, values: [] });
          this.groups.get(label).values.push(raw);
        }
        this.brand = this.querySelector('[data-brand]');
        this.model = this.querySelector('[data-model]');
        this.modelPlaceholder = this.model.options[0].textContent;
        this.status = this.querySelector('[data-status]');
        for (const brand of [...new Set([...this.groups.values()].map(x => x.brand))].sort()) this.brand.add(new Option(brand, brand));
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.querySelector('[role=tablist]').hidden = false;
        this.querySelector('[data-plate-form]').hidden = false;
        this.querySelector('[data-model-form]').hidden = false;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.setTab(tab.dataset.tab));
          tab.addEventListener('keydown', e => {
            let next;
            if (e.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            e.preventDefault(); this.setTab(this.tabs[next].dataset.tab); this.tabs[next].focus();
          });
        });
        for (const panel of this.querySelectorAll('[data-panel]')) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(x => x.dataset.tab === panel.dataset.panel).id);
        }
        this.setTab(this.dataset.locale === 'nl' ? 'plate' : 'model');
        this.brand.addEventListener('change', () => this.populateModels());
        this.model.addEventListener('change', () => this.querySelector('[data-model-button]').disabled = !this.model.value);
        this.querySelector('[data-model-form]').addEventListener('submit', e => {
          e.preventDefault();
          const group = this.groups.get(this.model.value);
          if (!group) return;
          const url = new URL(this.dataset.collectionUrl, location.origin);
          for (const value of group.values) url.searchParams.append('filter.p.m.custom.model', value);
          location.assign(url.href);
        });
        this.querySelector('[data-plate-form]').addEventListener('submit', e => { e.preventDefault(); this.lookup(); });
        this.querySelector('[data-plate]').addEventListener('input', () => {
          this.querySelector('[data-plate]').value = this.querySelector('[data-plate]').value.toUpperCase();
          if (this.controller) this.controller.abort();
          this.status.textContent = '';
        });
        if (!this.groups.size) { this.setTab('part'); this.tabs.find(x => x.dataset.tab === 'model').disabled = true; }
        this.modelsReady = true;
      }
      canonical(value) {
        return String(value).trim().replace(/\s+/g, ' ').replace(/^mercedes[ -]?benz\s*/i, 'Mercedes-Benz ').replace(/^mercedes citan$/i,'Mercedes-Benz Citan').replace(/^c[iI]tro[eë]n /i,'Citroën ').replace(/^f[iI]at /i,'Fiat ').replace(/^volkwagen /i,'Volkswagen ').replace(/connnect/i,'Connect').replace(/monvao/i,'Movano').replace(/pro\s?ace/i,'ProAce').replace(/\bvivaro\b/i,'Vivaro').replace(/\bmaster\b/i,'Master').replace(/\bmaste iv\b/i,'Master IV');
      }
      brandOf(value) {
        return ['Citroën','Dacia','Fiat','Ford','Iveco','MAN','Mercedes-Benz','Nissan','Opel','Peugeot','Renault','Toyota','Volkswagen'].find(brand => value.toLowerCase().startsWith(brand.toLowerCase() + ' '));
      }
      normalize(value) { return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,''); }
      setTab(name) {
        this.tabs.forEach(tab => { const active = tab.dataset.tab === name; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        this.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = panel.dataset.panel !== name);
      }
      populateModels(preferred) {
        this.model.replaceChildren(new Option(this.modelPlaceholder, ''));
        for (const group of [...this.groups.values()].filter(x => x.brand === this.brand.value).sort((a,b) => a.label.localeCompare(b.label))) this.model.add(new Option(group.label.replace(group.brand+' ',''), group.label));
        this.model.disabled = !this.brand.value;
        this.model.value = preferred || '';
        this.querySelector('[data-model-button]').disabled = !this.model.value;
      }
      vehicleModel(tradeName) {
        const normalizedTradeName = this.normalize(tradeName);
        const models = [
          ['Transit Custom', 'transitcustom'],
          ['Transit Connect', 'transitconnect'],
          ['Proace City', 'proacecity'],
          ['Crafter', 'crafter'],
          ['Transporter', 'transporter'],
          ['Caddy', 'caddy'],
          ['Sprinter', 'sprinter'],
          ['Vito', 'vito'],
          ['Citan', 'citan'],
          ['Master', 'master'],
          ['Trafic', 'trafic'],
          ['Kangoo', 'kangoo'],
          ['Movano', 'movano'],
          ['Vivaro', 'vivaro'],
          ['Combo', 'combo'],
          ['Boxer', 'boxer'],
          ['Expert', 'expert'],
          ['Partner', 'partner'],
          ['Jumper', 'jumper'],
          ['Jumpy', 'jumpy'],
          ['Berlingo', 'berlingo'],
          ['Ducato', 'ducato'],
          ['Scudo', 'scudo'],
          ['Doblo', 'doblo'],
          ['Transit', 'transit'],
          ['Daily', 'daily'],
          ['TGE', 'tge'],
          ['Proace', 'proace'],
          ['Dokker', 'dokker'],
          ['NV400', 'nv400'],
          ['NV300', 'nv300'],
          ['Interstar', 'interstar'],
          ['Primastar', 'primastar'],
        ];
        const match = models.find((model) => normalizedTradeName.includes(model[1]));
        if (match) return match[0];

        const ignored = /^(bluehdi|cdi|dci|hdi|multijet|tdi)$/i;
        const fallback = String(tradeName || '')
          .split(/\s+/)
          .find((part) => /[a-zÀ-ÿ]{3,}/i.test(part) && !ignored.test(part));
        if (!fallback) return '';
        return fallback.toLowerCase().replace(/(^|\s|-)[a-z]/g, (letter) => letter.toUpperCase());
      }

      modelSearchQuery(model) {
        const escapedModel = String(model).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        return `(title:"${escapedModel}" OR tag:"${escapedModel}")`;
      }

      async lookup() {
        const plate = this.querySelector('[data-plate]').value.toUpperCase().replace(/[^A-Z0-9]/g,'');
        this.status.dataset.error = 'false';
        if (!/^[A-Z0-9]{6}$/.test(plate)) { this.status.textContent = this.messages.invalid; this.status.dataset.error = 'true'; this.querySelector('[data-plate]').focus(); return; }
        if (this.controller) this.controller.abort();
        const controller = new AbortController(); this.controller = controller;
        const button = this.querySelector('[data-lookup]');
        button.disabled = true; button.setAttribute('aria-busy','true'); this.status.textContent = this.messages.loading;
        const timeout = setTimeout(() => controller.abort('timeout'),12000);
        try {
          const url = new URL('https://opendata.rdw.nl/resource/m9d7-ebf2.json');
          url.searchParams.set('kenteken',plate); url.searchParams.set('$select','merk,handelsbenaming'); url.searchParams.set('$limit','1');
          const response = await fetch(url,{headers:{Accept:'application/json'},signal:controller.signal});
          if (!response.ok) throw new Error('Lookup unavailable');
          const vehicles = await response.json();
          if (!Array.isArray(vehicles) || !vehicles.length) { this.status.textContent=this.messages.notFound; this.status.dataset.error='true'; return; }
          if (controller.signal.aborted) return;
          const vehicle = vehicles[0];
          const model = this.vehicleModel(vehicle.handelsbenaming);
          if (!model) { this.status.textContent=this.messages.notFound; this.status.dataset.error='true'; return; }
          this.status.textContent = this.messages.found + ' ' + [vehicle.merk, model].filter(Boolean).join(' ') + '.';
          // Match the search page: search every product title and tag for the model.
          const searchUrl = new URL(this.dataset.searchUrl, location.origin);
          searchUrl.searchParams.set('q', this.modelSearchQuery(model));
          searchUrl.searchParams.set('vehicle_model', model);
          searchUrl.searchParams.set('type', 'product');
          location.assign(searchUrl.href);
        } catch (error) {
          if (!controller.signal.aborted || controller.signal.reason === 'timeout') { this.status.textContent=this.messages.error; this.status.dataset.error='true'; }
        } finally { clearTimeout(timeout); if (this.controller === controller) { button.disabled=false; button.removeAttribute('aria-busy'); } }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adp-partner-schadeherstellers"] && !Shopify.designMode) return;
  try {
    
  const resetPartnerForm = (form) => {
    const button = form.querySelector('.adp-partner__form-submit');
    const status = form.querySelector('.adp-partner__submit-status');

    form.dataset.submitting = 'false';
    form.removeAttribute('aria-busy');

    if (button) {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-label');
    }

    if (status) status.textContent = '';
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.adp-partner__form');
    if (!form) return;

    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }

    if (!form.checkValidity()) return;

    const button = form.querySelector('.adp-partner__form-submit');
    const status = form.querySelector('.adp-partner__submit-status');
    const loadingLabel = button?.dataset.loadingLabel || 'Aanvraag wordt verstuurd…';

    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-label', loadingLabel);
    }

    if (status) status.textContent = loadingLabel;
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.adp-partner a[href*="-form-card"]');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    const firstField = target?.querySelector('input:not([type="hidden"])');
    if (!firstField) return;

    window.setTimeout(() => firstField.focus({ preventScroll: true }), 450);
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.adp-partner__form').forEach(resetPartnerForm);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('vehicle-finder')) {
    customElements.define(
      'vehicle-finder',
      class VehicleFinder extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.plateInput = this.querySelector('[data-vehicle-plate]');
          this.lookupButton = this.querySelector('[data-vehicle-lookup]');
          this.status = this.querySelector('[data-vehicle-status]');
          this.searchInput = document.getElementById('Search-In-Template');
          this.searchForm = this.searchInput ? this.searchInput.closest('form') : null;
          this.requestedModel = new URLSearchParams(window.location.search).get('vehicle_model') || '';

          if (this.searchInput && this.searchForm && this.requestedModel) {
            this.searchInput.value = this.requestedModel;
            this.searchForm.addEventListener('submit', () => {
              if (this.normalize(this.searchInput.value) === this.normalize(this.requestedModel)) {
                this.searchInput.value = this.modelSearchQuery(this.requestedModel);
              }
            });
          }

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.lookupPlate();
          });
          this.plateInput.addEventListener('input', () => {
            this.plateInput.value = this.plateInput.value.toUpperCase();
          });
        }

        normalize(value) {
          return String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '');
        }

        searchBrand(brand) {
          const aliases = {
            mercedesbenz: 'Mercedes',
            mercedes: 'Mercedes',
            volkswagen: 'Volkswagen',
            citroen: 'Citroën',
            man: 'MAN',
          };
          const normalized = this.normalize(brand);
          if (aliases[normalized]) return aliases[normalized];
          return String(brand || '')
            .toLowerCase()
            .replace(/(^|\s|-)[a-z]/g, (letter) => letter.toUpperCase());
        }

        vehicleModel(tradeName) {
          const normalizedTradeName = this.normalize(tradeName);
          const models = [
            ['Transit Custom', 'transitcustom'],
            ['Transit Connect', 'transitconnect'],
            ['Proace City', 'proacecity'],
            ['Crafter', 'crafter'],
            ['Transporter', 'transporter'],
            ['Caddy', 'caddy'],
            ['Sprinter', 'sprinter'],
            ['Vito', 'vito'],
            ['Citan', 'citan'],
            ['Master', 'master'],
            ['Trafic', 'trafic'],
            ['Kangoo', 'kangoo'],
            ['Movano', 'movano'],
            ['Vivaro', 'vivaro'],
            ['Combo', 'combo'],
            ['Boxer', 'boxer'],
            ['Expert', 'expert'],
            ['Partner', 'partner'],
            ['Jumper', 'jumper'],
            ['Jumpy', 'jumpy'],
            ['Berlingo', 'berlingo'],
            ['Ducato', 'ducato'],
            ['Scudo', 'scudo'],
            ['Doblo', 'doblo'],
            ['Transit', 'transit'],
            ['Daily', 'daily'],
            ['TGE', 'tge'],
            ['Proace', 'proace'],
            ['Dokker', 'dokker'],
            ['NV400', 'nv400'],
            ['NV300', 'nv300'],
            ['Interstar', 'interstar'],
            ['Primastar', 'primastar'],
          ];
          const match = models.find((model) => normalizedTradeName.includes(model[1]));
          if (match) return match[0];

          const ignored = /^(bluehdi|cdi|dci|hdi|multijet|tdi)$/i;
          const fallback = String(tradeName || '')
            .split(/\s+/)
            .find((part) => /[a-zÀ-ÿ]{3,}/i.test(part) && !ignored.test(part));
          if (!fallback) return '';
          return fallback.toLowerCase().replace(/(^|\s|-)[a-z]/g, (letter) => letter.toUpperCase());
        }

        modelSearchQuery(model) {
          const escapedModel = String(model).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          return `(title:"${escapedModel}" OR tag:"${escapedModel}")`;
        }

        setStatus(message, state = '') {
          this.status.textContent = message;
          this.status.dataset.state = state;
        }

        async lookupPlate() {
          const plate = this.plateInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          if (!/^[A-Z0-9]{6}$/.test(plate)) {
            this.setStatus(this.dataset.invalid, 'error');
            this.plateInput.focus();
            return;
          }

          this.lookupButton.setAttribute('aria-busy', 'true');
          this.lookupButton.disabled = true;
          this.setStatus('');

          try {
            const url = new URL(this.dataset.endpoint);
            url.searchParams.set('kenteken', plate);
            url.searchParams.set('$select', 'kenteken,merk,handelsbenaming,voertuigsoort');
            url.searchParams.set('$limit', '1');

            const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('RDW ' + response.status);

            const vehicles = await response.json();
            if (!vehicles.length) {
              this.setStatus(this.dataset.notFound, 'error');
              return;
            }

            const vehicle = vehicles[0];
            const brand = this.searchBrand(vehicle.merk);
            const model = this.vehicleModel(vehicle.handelsbenaming);

            if (!model) {
              this.setStatus(this.dataset.notFound, 'error');
              return;
            }

            if (this.searchInput) this.searchInput.value = model;
            this.setStatus(this.dataset.found + ' ' + [brand, model].filter(Boolean).join(' ') + '.');

            const params = new URLSearchParams();
            params.set('q', this.modelSearchQuery(model));
            params.set('vehicle_model', model);
            params.set('type', 'product');
            window.location.assign(this.dataset.searchUrl + '?' + params.toString());
          } catch (error) {
            this.setStatus(this.dataset.error, 'error');
          } finally {
            this.lookupButton.removeAttribute('aria-busy');
            this.lookupButton.disabled = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
